import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import EditUserModal from 'flarum/common/components/EditUserModal';

export default () => {
    hide_subscriber_group();
}

function hide_subscriber_group() {
    extend(EditUserModal.prototype, 'oninit', function (vnode) {
        // Remove Subscriber group from groups list
        const GROUP_SUBSCRIBER_ID = 5;
        delete this.groups[GROUP_SUBSCRIBER_ID];
    });
}
